module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_19.2c06f865.jpg";